// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E_TE","toggleWrap":"styles_toggleWrap__2KCQT","content":"styles_content__2Fw5O","selectAreaCode":"styles_selectAreaCode__2EdMN"};